import jqueryValidate from "jquery-validation";
import * as ko from 'knockout';
window.ko = ko;
window.vm = new ViewModel();
import intlTelInput from 'intl-tel-input';
import { Modal } from 'bootstrap';

var min_load = 500;
var ajaxTime = 0;
var wait = 0;
var totalTime = 0;

const global_func = require('./globals.js');

jQuery(document).ready(function($) {

  if(document.getElementById('bookingErrorModal')) {
    window.bookingErrorModal = Modal.getOrCreateInstance(document.querySelector('#bookingErrorModal'), {
      keyboard: false
    });
  }

  if(document.getElementById('newBookingModal')) {
    window.newBookingModal = Modal.getOrCreateInstance(document.querySelector('#newBookingModal'), {
      keyboard: false,
      backdrop: 'static',
    });
  }

  $('.booking-details-public').show();

  $('.open-new-booking-modal').click(function(event) {
    event.preventDefault();
    $('form.booking-form').trigger('reset');
    $("form.booking-form").find('input[name="booking_retry_url"]').val("");
    $("form.booking-form").find('input[name="payment_retry_url"]').val("");
    $('form.booking-form .current-employee').html('');
    ResetObservs();
    if(window.newBookingModal) {
      window.newBookingModal.show();
    }
  });

  $('.booking-form input[name="date"], .edit-booking-form input[name="date"]').change(function(event) {
    get_promotions_for_date($(this).val(), $(this).closest("form"));
  });

  $('body').on('change', '.edit-booking-form input[name="date"]', function(event) {
    get_promotions_for_date($(this).val(), $(this).closest("form"));
  });

  $('body').on('change', '.edit-booking-form input[name="promotion"], .edit-booking-form input[name="date"], .edit-booking-form input[name="adults"],  .edit-booking-form input[name="children"],  .edit-booking-form input[name="infants"],  .edit-booking-form input[name="mobility_needs"],  .edit-booking-form input[name="area_hire"],  .edit-booking-form input[name="custom_time_on_table_check"],  .edit-booking-form select[name="custom_time_on_table"]', function(event) {
    if($(this).closest("form").find('input[name="time"]:checked').val() == 'custom') {
      get_times_for_promotion($(this).closest("form"), true);
    } else {
      get_times_for_promotion($(this).closest("form"));
    }
  });

  if($('#newBookingModal').length) {
    $('#newBookingModal').on('show.bs.modal', function () {
      var form = $('#newBookingModal').find('form.booking-form');
      form.trigger("reset");
      form.find('.step').removeClass('active');
      form.find('.step').first().addClass('active');
      form.find('input[name="store_card_details"]').val(0);
    });

    $('#newBookingModal').on('shown.bs.modal', function () {
      var form = $('#newBookingModal').find('form.booking-form');
      var default_date = $('form.get-diary-form input[name="date"]').first().val();
      $('.booking-form input[name="date"]').first().val(default_date);
      $('.booking-form input[name="date"]').first().trigger('change');
      $('.booking-form input[name="date"]').trigger('open-new-booking');
      $('input[name="pin"]').focus();
      diary_steps(form.first());
    });
  } else {
    var form = $('body').find('form.booking-form');
    form.find('.step').removeClass('active');
    form.find('.step').first().addClass('active');
    diary_steps(form.first());
  }

  $('body').on('submit', '.edit-booking-form', function(event) {
    event.preventDefault();
    edit_booking(this);
  });

  $('body').on('click', 'form.booking-form .booking-form-nav .next button', function(event) {
    event.preventDefault();
    diary_step_next($(this).parents('form.booking-form').last());
  });

  $('body').on('click', 'form.booking-form .store-card-details-link', function(event) {
    event.preventDefault();
    var form = $(this).closest('form.booking-form');
    $(form).find('input[name="store_card_details"]').val(1);
    diary_step_next(form);
  });

  $('body').on('click', 'form.booking-form .booking-form-nav .back button', function(event) {
    event.preventDefault();
    diary_step_back($(this).parents('form.booking-form').last());
  });

  $('body').on('change', 'form.booking-form input[name="location"]', function(event) {
    update_location_details(this);
    diary_step_next($(this).parents('form.booking-form').last());
  });

  $('body').on('change', 'form.booking-form input[name="promotion"]', function(event) {
    update_promotion_details(this);
  });

  $('body').on('change', 'form.edit-booking-form input[name="promotion"]', function(event) {
    update_promotion_details(this);
  });

  $('body').on('change', 'form.new-booking-form input[name="promotion"]', function(event) {
    var form = $(this).parents('form.booking-form').last();
    diary_step_next(form);
  });

  $('body').on('change', 'form.edit-booking-form select[name="custom_time"]', function(event) {
    var checked_time = $('form.edit-booking-form input[name="time"]:checked').val();
    if(checked_time == "custom") {
      get_times_for_promotion($('form.edit-booking-form'), true);
    }
  });

  $('#editBookingModal').on('newPaymentIntent', function (event, booking_form) {
    get_payment_intent(booking_form);
  });

  $('form.payment-link-form').on('submit', function(event) {
    event.preventDefault();
    $(this).find('button').hide();
    get_payment_intent(this);
  });

  if($('form.payment-link-form').length) {
    $('form.payment-link-form').find('.payment-hold').hide();
  }

  $('#editBookingModal').on('newPaymentAdmin', function (event, booking_form) {
    edit_booking(booking_form, true);
  });
  

  $('#editBookingModal').on('bookingLoaded', function () {
    update_promotion_details('form.edit-booking-form input[name="promotion"]:checked');
    get_times_for_promotion($('form.edit-booking-form'), true, true);
    $('#editBookingModal .phone-selector').each(function(index, el) {
      intlTelInput(el, {
          utilsScript: '../js/utils.js',
          initialCountry: "GB"
      });
    });
   
  });

  $('#editBookingModal').on('bookingLoading', function () {
    ResetObservs();
    var checked_dietary = $('form.edit-booking-form input[name="dietary"]:checked');
    if(checked_dietary) {
      vm.dietary(checked_dietary.val());
    }

    var checked_mobility = $('form.edit-booking-form input[name="mobility_needs"]:checked');
    if(checked_mobility) {
      vm.mobility(checked_mobility.val());
    }

    var checked_voucher = $('form.edit-booking-form input[name="voucher"]:checked');
    if(checked_voucher) {
      vm.voucher(checked_voucher.val());
    }
  });

  $('body').on('change', 'form.booking-form input[name="time"], form.edit-booking-form input[name="time"]', function(event) {
    retrieve_tables($(this).closest("form"));
  });

  $('body').on('change', 'form.booking-form .available-tables-hold, form.edit-booking-form .available-tables-hold', function(event) {
    show_tables($(this).closest("form"));
  });

  $('body').on('click', 'form.booking-form .chosen-tables .btn, form.edit-booking-form .chosen-tables .btn', function(event) {
    event.preventDefault();
    $(this).closest("form").find('.tables-select-hold').toggle(400, function() {
      if($(this).is(":visible")) {
        $(this).find('.available-tables-hold').select2('focus');
      }
    });
  });

  $('body').on('click', 'form .num-selector .before', function(event) {
    event.preventDefault();
    num_selector_minus($(this).parents('.num-selector').last());
  });

  $('body').on('click', 'form .num-selector .after', function(event) {
    event.preventDefault();
    num_selector_plus($(this).parents('.num-selector').last());
  });

  $('body').on('change keyup input', 'form.booking-form input[name="deposit_due"]', function(event) {
    check_deposit_button_text(this);
  });

  $('body').on('change', 'form input[name="adults"],form input[name="children"],form input[name="infants"],form input[name="highchairs"]', function(event) {
    var el = $(this).parent().parent()[0];
    ko.cleanNode(el);

    ko.applyBindings(vm, el);
  });

  window.booking_form_validator = $("form.booking-form").validate({
    errorPlacement: function(error, element) {
      error.appendTo( element.parents('.form-element').first());
    },
    ignore: ":hidden:not(.chosen-select),.select2-search__field",
  });
  ko.applyBindings(vm);

  $('.phone-selector').each(function(index, el) {
    intlTelInput(el, {
        utilsScript: '../js/utils.js',
        initialCountry: "GB"
    });
  });

  $('body').on('submit', 'form.booking-form', function(event){
    event.preventDefault();
  });

  $('body').on('click', '.booking-form .submit button', function(event) {
    event.preventDefault();
    var form = $(this).closest('form.new-booking-form');
    submit_new_booking_form(form);
  });

  $('body').on('change', 'form.booking-form input[name="email_declined"], form.edit-booking-form input[name="email_declined"]', function(event) {
    if($(this).prop('checked')) {
      $(this).parent().parent().find('input[name="email"]').prop('required',false);
      $(this).parent().parent().find('input[name="email"]').prop('disabled',true);
    } else {
      $(this).parent().parent().find('input[name="email"]').prop('required',true);
      $(this).parent().parent().find('input[name="email"]').prop('disabled',false);
    }
  });

  $('body').on('click', 'form.booking-form a.submit-payment, form.edit-booking-form a.submit-payment, form.payment-link-form a.submit-payment', function(event) {
    event.preventDefault();
    submit_card_payment(this);
  });

  $(document).on("keydown", "form.booking-form, form.edit-booking-form", function(event) {
    if(!$(event.target).is('textarea')) {
      return event.key != "Enter";
    }
  });

  $(document).on('keydown', 'form.booking-form input[name="pin"]', function(event) { 
    if(event.key=="Enter") {
      diary_step_next($(this).closest('form.booking-form'));
    }
  });

  $(document).on('keydown', '#rotaCloudModal input[name="pin"]', function(event) { 
    if(event.key=="Enter") {
      return get_employee(true);
    }
  });

  $(document).on('submit', '#rotaCloudModal form', function(event) { 
    event.preventDefault();
  });

  $(document).on('keyup', 'form.booking-form input[name="pin"]', function(event) { 
    if($(this).val().length==4) {
      diary_step_next($(this).closest('form.booking-form'));
    }
  });

  $(document).on('keyup', '#rotaCloudModal input[name="pin"]', function(event) { 
    if($(this).val().length==4) {
      get_employee(true);
    }
  });

  $('body').on('submit', '#confirmEditBookingModal form', function(event) {
    event.preventDefault();
    $('#editBookingModal form').append('<input name="confirmed" type="hidden" value="confirmed" />');
    $('#editBookingModal form').trigger('submit');
    window.confirmEditBookingModal.hide();
  });
});

function update_location_details(location) {
  if($(location).attr('data-logo')) {
    vm.locationLogo($(location).attr('data-logo'));
  } else {
    vm.locationLogo(false);
  }

  if($(location).attr('data-name')) {
    vm.location($(location).attr('data-name'));
  } else {
    vm.location(null);
  }
}

function update_promotion_details(promotion) {
  if($(promotion).attr('data-name')) {
    vm.promotionName($(promotion).attr('data-name'));
  } else {
    vm.promotionName(false);
  }

  if($(promotion).attr('data-allow-children')) {
    vm.promotionChildren($(promotion).attr('data-allow-children'));
  } else {
    vm.promotionChildren(false);
  }

  if($(promotion).attr('data-show-mobility')) {
    vm.promotionShowMobility($(promotion).attr('data-show-mobility'));
  } else {
    vm.promotionShowMobility(false);
  }

  if($(promotion).attr('data-show-wheelchair')) {
    vm.promotionShowWheelchair($(promotion).attr('data-show-wheelchair'));
  } else {
    vm.promotionShowWheelchair(false);
  }

  if($(promotion).attr('data-allow-infants')) {
    vm.promotionInfants($(promotion).attr('data-allow-infants'));
  } else {
    vm.promotionInfants(false);
  }

  if($(promotion).attr('data-price-adult')) {
    vm.promotionPriceAdult($(promotion).attr('data-price-adult'));
  } else {
    vm.promotionPriceAdult('');
  }

  if($(promotion).attr('data-price-child')) {
    vm.promotionPriceChild($(promotion).attr('data-price-child'));
  } else {
    vm.promotionPriceChild('');
  }

  if($(promotion).attr('data-max-children')) {
    vm.promotionMaxChildren($(promotion).attr('data-max-children'));
  } else {
    vm.promotionMaxChildren('');
  }

  if($(promotion).attr('data-accepts-vouchers')) {
    vm.promotionAcceptsVouchers($(promotion).attr('data-accepts-vouchers'));
  } else {
    vm.promotionAcceptsVouchers(false);
  }

  if($(promotion).attr('data-allow-area-hire')) {
    vm.promotionAllowAreaHire($(promotion).attr('data-allow-area-hire'));
  } else {
    vm.promotionAllowAreaHire(false);
  }

  if($(promotion).attr('data-max-infants')) {
    vm.promotionMaxInfants($(promotion).attr('data-max-infants'));
  } else {
    vm.promotionMaxInfants('');
  }

  if($(promotion).attr('data-max-high-chairs')) {
    vm.promotionMaxHighChairs($(promotion).attr('data-max-high-chairs'));
  } else {
    vm.promotionMaxHighChairs('');
  }

  if($(promotion).attr('data-mobility-more-info')) {
    vm.promotionMobilityMoreInfo($(promotion).attr('data-mobility-more-info'));
  } else {
    vm.promotionMobilityMoreInfo('');
  }

  if($(promotion).attr('data-children-more-info')) {
    vm.promotionChildrenMoreInfo($(promotion).attr('data-children-more-info'));
  } else {
    vm.promotionChildrenMoreInfo('');
  }

  if($(promotion).attr('data-infants-more-info')) {
    vm.promotionInfantsMoreInfo($(promotion).attr('data-infants-more-info'));
  } else {
    vm.promotionInfantsMoreInfo('');
  }

  if($(promotion).attr('data-high-chairs-more-info')) {
    vm.promotionHighChairsMoreInfo($(promotion).attr('data-high-chairs-more-info'));
  } else {
    vm.promotionHighChairsMoreInfo('');
  }

  if($(promotion).attr('data-terms')) {
    vm.promotionTerms($(promotion).attr('data-terms'));
  } else {
    vm.promotionTerms('');
  }

};

function submit_new_booking_form(form) {
  window.booking_form_validator.form();
  if(window.booking_form_validator.valid()) {
    new_booking(form);
  };
}

ko.bindingHandlers.initializeValue = {
    init: function(element, valueAccessor) {
        if (element.getAttribute('value')) {
            valueAccessor()(element.getAttribute('value'));
        } else if (element.tagName === 'SELECT') {
            valueAccessor()(element.options[element.selectedIndex].value);
        }
    },
    update: function(element, valueAccessor) {
        var value = valueAccessor();
        element.setAttribute('value', ko.utils.unwrapObservable(value));
    }
};

ko.bindingHandlers['initChecked'] = {
    init: function (element, valueAccessor, allBindings) {
        var checked = valueAccessor();
        if (element.checked) {
            checked(element.value);
        }
  }
};

ko.bindingHandlers.htmlWithBinds = {
    init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
      if(valueAccessor) {
         var value = ko.unwrap(valueAccessor());
         if(value) {
          value = value.replaceAll("[children]", ko.utils.unwrapObservable(bindingContext.$data.children));
          element.innerHTML = value;
         }
      }
    },
    update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
        if(valueAccessor) {
          var value = ko.unwrap(valueAccessor());
           if(value) {
            value = value.replaceAll("[children]", ko.utils.unwrapObservable(bindingContext.$data.children));
            if(bindingContext.$data.children && ko.utils.unwrapObservable(bindingContext.$data.children) == 1) {
              value = value.replaceAll("[childrenPlural]", "child");
            } else {
              value = value.replaceAll("[childrenPlural]", "children");
            }

            value = value.replaceAll("[infants]", ko.utils.unwrapObservable(bindingContext.$data.infants));
            if(bindingContext.$data.infants && ko.utils.unwrapObservable(bindingContext.$data.infants) == 1) {
              value = value.replaceAll("[infantsPlural]", "infant");
            } else {
              value = value.replaceAll("[infantsPlural]", "infants");
            }

            value = value.replaceAll("[highchairs]", ko.utils.unwrapObservable(bindingContext.$data.highchairs));
            if(bindingContext.$data.highchairs && ko.utils.unwrapObservable(bindingContext.$data.highchairs) == 1) {
              value = value.replaceAll("[highchairsPlural]", "high chair");
            } else {
              value = value.replaceAll("[highchairsPlural]", "high chairs");
            }
            
            element.innerHTML = value;
           }
        }
    }
}

function ViewModel () {
  this.bookingDate = ko.observable();
  this.bookingDateHuman = ko.observable();
  this.adults = ko.observable();
  this.infants = ko.observable();
  this.firstName = ko.observable();
  this.lastName = ko.observable();
  this.children = ko.observable();
  this.highchairs = ko.observable();
  this.dietary = ko.observable();
  this.voucher = ko.observable();
  this.location = ko.observable();
  this.areaHire = ko.observable();
  this.areaDepositType = ko.observable();
  this.customTimeOnTableCheck = ko.observable();
  this.bookingDepositDue = ko.observable();
  this.paymentsTotal = ko.observable();
  this.bookingDepositDueText = ko.observable();
  this.paymentsTotalText = ko.observable();
  this.promotionChildren = ko.observable();
  this.promotionInfants = ko.observable();
  this.promotionName = ko.observable();
  this.promotionPriceAdult = ko.observable();
  this.promotionPriceChild = ko.observable();
  this.promotionMaxChildren = ko.observable();
  this.promotionMaxInfants = ko.observable();
  this.promotionMaxHighChairs = ko.observable();
  this.promotionShowMobility = ko.observable();
  this.promotionShowWheelchair = ko.observable();
  this.promotionAcceptsVouchers = ko.observable();
  this.promotionAllowAreaHire = ko.observable();
  this.promotionMobilityMoreInfo = ko.observable();
  this.promotionChildrenMoreInfo = ko.observable();
  this.promotionInfantsMoreInfo = ko.observable();
  this.promotionHighChairsMoreInfo = ko.observable();
  this.promotionTerms = ko.observable();
  this.locationLogo = ko.observable();
  this.time = ko.observable();
  this.mobility = ko.observable();
}

function ResetObservs () {
  vm.adults(0);
  vm.infants(0);
  vm.children(0);
  vm.highchairs(0);
  vm.areaHire(0);
  vm.firstName("");
  vm.lastName("");
  vm.areaDepositType(null);
  vm.customTimeOnTableCheck(null)
  vm.bookingDate(null);
  vm.bookingDateHuman(null);
  vm.dietary(null);
  vm.voucher(null);
  vm.mobility(null);
  vm.location(null);
  vm.bookingDepositDue(null);
  vm.paymentsTotal(null);
  vm.bookingDepositDueText(null);
  vm.paymentsTotalText(null);
  vm.promotionName(null);
  vm.promotionChildren(null);
  vm.promotionInfants(null);
  vm.promotionPriceAdult(null);
  vm.promotionPriceChild(null);
  vm.promotionMaxChildren(null);
  vm.promotionMaxInfants(null);
  vm.promotionMaxHighChairs(null);
  vm.promotionShowMobility(null);
  vm.promotionShowWheelchair(null);
  vm.promotionMobilityMoreInfo(null);
  vm.promotionChildrenMoreInfo(null);
  vm.promotionInfantsMoreInfo(null);
  vm.promotionHighChairsMoreInfo(null);
  vm.promotionAcceptsVouchers(null);
  vm.promotionAllowAreaHire(null);
  vm.promotionTerms(null);
  vm.time(null);
}

function show_tables(form) {
  $(form).find('.chosen-tables .tables-hold').html('');
  $(form).find('.available-tables-hold').find('option:selected').each(function(index, el) {
    $(form).find('.chosen-tables .tables-hold').append('<span class="badge bg-primary">'+$(el).attr('data-table')+' <small>('+$(el).attr('data-covers')+')<small></span>');
  });
}

function retrieve_tables(form) {
  $(form).find('.available-tables-hold').html('');
  var selected_time = $(form).find('input[name="time"]:checked');
  if($(selected_time).attr('data-tables')) {
    var tables_array = JSON.parse($(selected_time).attr('data-tables'));
    if($(selected_time).attr('data-best')) {
      var best_tables = JSON.parse($(selected_time).attr('data-best'));
    }
    
    $.each(tables_array, function(index, val) {
      var selected_html = "";
      if(jQuery.inArray(index.toString(), best_tables) != -1) {
        selected_html = " selected ";
      }
      $(form).find('.available-tables-hold').append('<option data-covers="'+ val +'" data-table="'+ index +'" ' + selected_html +' value="'+index+'">'+index+' ('+ val +')'+'</option>');
      
    });
  }
  $(form).find('.available-tables-hold').select2({
    dropdownParent: $(form).closest('.modal'),
    theme: "bootstrap-5",
  });
  show_tables(form);
}

function get_locations() {
  let data = {};
  data['_token'] = $('.booking-form input[name="_token"]').val();
  data['company_id'] = $('.booking-form input[name="company_id"]').val();
  $('.booking-form .locations-hold').html($('.ajax-loader-hold .ajax-loader').clone());
  
  wait = 0;
  ajaxTime = new Date().getTime();
  disable_step_buttons();

  $.ajax({
    url: '/get-locations',
    method: 'GET',
    data: data,
    dataType: 'JSON',
    cache: false,
    processData: true,
    contentType: "multipart/form-data",
    success:function(response)
    {
      totalTime = new Date().getTime()-ajaxTime;
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        alert(response.message);
      }
      if(response.response_html) {
        if(totalTime < min_load) {
          wait = min_load-totalTime;
        }
        
        setTimeout(function() {
          ko.cleanNode($('.locations-hold')[0]);
          $('.booking-form .locations-hold').html(response.response_html);
          ko.applyBindings(vm, $('.locations-hold')[0]);
          enable_step_buttons();
        }, wait);
      }
    },
    error: function(response) {
      totalTime = new Date().getTime()-ajaxTime;
      if(totalTime < min_load) {
        wait = min_load-totalTime;
      }
      setTimeout(function() {
        ko.cleanNode($('.locations-hold')[0]);
        $('.booking-form .locations-hold').html('');
        ko.applyBindings(vm, $('.locations-hold')[0]);
        if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
          $('.booking-form .locations-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
        }
        enable_step_buttons();
      }, wait);
    }
  });
}

function get_employee(is_edit = false) {
  let data = {};
  
  

  if(!is_edit) {
    data['_token'] = $('.booking-form input[name="_token"]').val();
    data['pin'] = $('.booking-form input[name="pin"]').val();
    $('.booking-form .pin-load').html($('.ajax-loader-hold .ajax-loader').clone()).show();
    $('.booking-form .pin-hold').hide();
    $('.booking-form .current-employee').html('');
    $('.booking-form .current-employee').hide();
    $('.booking-form input[name="employee"]').val('');
  } else {
    data['_token'] = $('#editBookingModal input[name="_token"]').val();
    data['pin'] = $('#rotaCloudModal input[name="pin"]').val();
    $('#rotaCloudModal input[name="pin"]').val('');
    window.rotaCloudModal.hide();
  }

  disable_step_buttons();

  $.ajax({
    url: '/get-employee',
    method: 'GET',
    data: data,
    dataType: 'JSON',
    cache: false,
    processData: true,
    contentType: "multipart/form-data",
    success:function(response)
    {
      if(response.employee) {
        if(!is_edit) {
          $('.booking-form input[name="employee"]').val(response.employee);
          $('.booking-form .current-employee').show().html('Current employee: ' + response.employee);
        } else {
          $('#editBookingModal input[name="employee"]').val(response.employee);
          $('#editBookingModal .current-employee').show().html('Current employee: ' + response.employee);
        }
      }
      enable_step_buttons();
      $('.booking-form .pin-load').hide();
      $('.booking-form .pin-hold').show();
    },
    error: function(response) {
      enable_step_buttons();
      $('.booking-form .pin-load').hide();
      $('.booking-form .pin-hold').show();
      $('.booking-form .current-employee').hide();
    }
  });
}

function get_promotions_for_date(date, form) {
  vm.bookingDate(date);
  vm.bookingDateHuman(formatDate(date));
  let data = {};
  data['date'] = date;
  data['_token'] = $(form).find('input[name="_token"]').val();
  if($(form).find('input[name="location"]:checked').length) {
    data['location'] = $(form).find('input[name="location"]:checked').val();
  } else {
    data['location'] = $(form).find('input[type="hidden"][name="location"]').val();
  }

  if($(form).find('input[name="promotion"]:checked').length) {
    data['promotion'] = $(form).find('input[name="promotion"]:checked').val();
  }
  
  $(form).find('.promotions-hold').html($('.ajax-loader-hold .ajax-loader').clone());
  
  wait = 0;
  ajaxTime = new Date().getTime();
  disable_step_buttons();

  $.ajax({
    url: '/get-promotions',
    method: 'GET',
    data: data,
    dataType: 'JSON',
    cache: false,
    processData: true,
    contentType: "multipart/form-data",
    success:function(response)
    {
      totalTime = new Date().getTime()-ajaxTime;
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.message);
        window.bookingErrorModal.show();
      }
      if(response.response_html) {
        if(totalTime < min_load) {
          wait = min_load-totalTime;
        }
        
        setTimeout(function() {
          ko.cleanNode($(form).find('.promotions-hold')[0]);
          $(form).find('.promotions-hold').html(response.response_html);
          ko.applyBindings(vm, $(form).find('.promotions-hold')[0]);
          enable_step_buttons();

          if($(form).find('input[name="promotion"]:checked').length) {
            update_promotion_details($(form).find('input[name="promotion"]:checked').last());
          } else {
            $(form).find('input[name="promotion"]').first().prop('checked', 'checked');
            update_promotion_details($(form).find('input[name="promotion"]:checked').last());
          }
        }, wait);
      }
    },
    error: function(response) {
      totalTime = new Date().getTime()-ajaxTime;
      if(totalTime < min_load) {
        wait = min_load-totalTime;
      }
      setTimeout(function() {
        ko.cleanNode($(form).find('.promotions-hold')[0]);
        $(form).find('.promotions-hold').html('');
        ko.applyBindings(vm, $(form).find('.promotions-hold')[0]);
        if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
          $(form).find('.promotions-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
        }
        enable_step_buttons();
      }, wait);
    }
  });
}


function get_times_for_promotion(form, custom_time = false, use_original_table = false) {
  let data = {};
  disable_step_buttons();
  
  data['date'] = $(form).find('input[name="date"]').val();
  data['_token'] = $(form).find('input[name="_token"]').val();
  
  if($(form).find('input[name="location"]:checked').length) {
    data['location'] = $(form).find('input[name="location"]:checked').val();
  } else {
    data['location'] = $(form).find('input[type="hidden"][name="location"]').val();
  }

  data['promotion'] = $(form).find('input[name="promotion"]:checked').val();
  data['adults'] = $(form).find('input[name="adults"]').val();
  data['children'] = $(form).find('input[name="children"]').val();
  data['infants'] = $(form).find('input[name="infants"]').val();
  data['mobility_needs'] = $(form).find('input[name="mobility_needs"]:checked').val();
  data['booking_id'] = $(form).find('input[name="booking_id"]').val();
  if(custom_time) {
    data['custom_time'] = $(form).find('select[name="custom_time"]').val();
  }

  if( $(form).find('input[name="area_hire"]:checked').length ) {
    data['area_hire'] = $(form).find('input[name="area_hire"]:checked').val();
  }

  if($(form).find('input[name="custom_time_on_table_check"]').length) {
    if( $(form).find('input[name="custom_time_on_table_check"]:checked').length ) {
      data['custom_time_on_table_check'] = $(form).find('input[name="custom_time_on_table_check"]:checked').val();
      data['custom_time_on_table'] = $(form).find('select[name="custom_time_on_table"]').val();
    } else {
      data['custom_time_on_table_check'] = 0;
    }
  }

  if( $(form).find('input[name="time"]:checked').length && $(form).find('input[name="time"]:checked').val()!="custom" ) {
    data['selected_time'] = $(form).find('input[name="time"]:checked').val();
  } else if($(form).find('input[name="original_booking_time"]').length) {
    data['selected_time'] = $(form).find('input[name="original_booking_time"]').val();
  }

  if(use_original_table && $(form).find('input[name="original_booking_tables"]').length) {
    data['selected_tables'] = jQuery.parseJSON($(form).find('input[name="original_booking_tables"]').val());
    data['use_original_table'] = true;
  } else if($(form).find('select[name="tables[]"] option:selected').length) {
    data['selected_tables'] = $(form).find('select[name="tables[]"] option:selected').map(function() {return $(this).val()}).toArray();
  } else if($(form).find('input[name="original_booking_tables"]').length) {
    data['selected_tables'] = jQuery.parseJSON($(form).find('input[name="original_booking_tables"]').val());
  }


  $(form).find('.times-hold').html('');

  $(form).find('.times-hold').html($('.ajax-loader-hold .ajax-loader').clone());
  $.ajax({
    url: '/get-times',
    method: 'GET',
    data: data,
    dataType: 'JSON',
    cache: false,
    processData: true,
    contentType: "multipart/form-data",
    success:function(response)
    {
      totalTime = new Date().getTime()-ajaxTime;
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.message);
        window.bookingErrorModal.show();
      }
      if(response.response_html) {
        if(totalTime < min_load) {
          wait = min_load-totalTime;
        }
        
        setTimeout(function() {

          ko.cleanNode($(form).find('.times-hold')[0]);
          $(form).find('.times-hold').html(response.response_html);
          var checked_time = $(form).find('.times-hold input[name="time"]:checked');
          if(checked_time) {
            vm.time(checked_time.val());
          }
          ko.applyBindings(vm, $(form).find('.times-hold')[0]);
          
          retrieve_tables(form);
      
        enable_step_buttons();
        }, wait);
      }
    },
    error: function(response) {
      totalTime = new Date().getTime()-ajaxTime;
      if(totalTime < min_load) {
        wait = min_load-totalTime;
      }
      if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
        setTimeout(function() {
        ko.cleanNode($(form).find('.times-hold')[0]);
        $(form).find('.times-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
        ko.applyBindings(vm, $(form).find('.times-hold')[0]);
        enable_step_buttons();
        }, wait);
      }
    }
  });
}

function new_booking(booking_form) {
  disable_step_buttons();
  var booking_url = '/new-booking'
  if($(booking_form).find('input[name="update_booking_url"]').length) {
    booking_url = $(booking_form).find('input[name="update_booking_url"]').val();
  }
  if($(booking_form).find('input[name="booking_retry_url"]').length && $(booking_form).find('input[name="booking_retry_url"]').val()!="") {
    booking_url = $(booking_form).find('input[name="booking_retry_url"]').val();
  }
  $.ajax({
    url: booking_url,
    method: 'POST',
    data: $(booking_form).serialize(),
    dataType: 'JSON',
    cache: false,
    processData: false,
    success:function(response)
    {
      $('#bookingErrorModal .error-modal-hold').html('');
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.message);
        window.bookingErrorModal.show();
        enable_step_buttons();
        $(booking_form).find('.payment-loading').hide();
        $(booking_form).find('.payment-hold').show();
        diary_step_back($(booking_form));
        resetPayment(booking_form);
      }
      if(response.success) {
        if(window.newBookingModal) {
          window.newBookingModal.hide();
        }
        if(response.booking_confirmation_url && $('body').hasClass('public')) {
          window.location = response.booking_confirmation_url;
        }
        if($('.get-diary-form').length && !$('body').hasClass('public')) {
          if(response.diary_date) {
            $('.get-diary-form input[name="date"]').val(response.diary_date);
            global_func.change_diary_date($('.get-diary-form').first());
          }
        }
        resetPayment(booking_form);
        $(booking_form).find('.payment-message').html('');
        $(booking_form).find('.payment-errors').html('');
        // $('.times-hold').html(response.response_html);
        $(booking_form).find('.payment-loading').hide();
        $(booking_form).find('.payment-hold').show();
        enable_step_buttons();
      }
    },
    error: function(response) {
      window.bookingErrorModal.show();
      $('#bookingErrorModal .error-modal-hold').html('');
      if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
        $('#bookingErrorModal .error-modal-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
      }
      $(booking_form).find('.payment-loading').hide();
      $(booking_form).find('.payment-hold').show();
      enable_step_buttons();
      resetPayment(booking_form);
      diary_step_back($(booking_form));
    }
  });
}

function edit_booking(form, load_booking=false) {
  disable_booking_modal_buttons();
  var booking_id = $(form).find('input[name="booking_id"]').val();
  $.ajax({
    url: 'edit-booking',
    method: 'PUT',
    data: $(form).serialize(),
    dataType: 'JSON',
    cache: false,
    processData: false,
    success:function(response)
    {
      $('#editBookingModal .edit-booking-error-hold').html('');
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        $('#editBookingModal .edit-booking-error-hold').html('<div class="alert alert-danger">'+response.message+'</div>');
        $('#editBookingModal .modal-body').scrollTop(0);
        enable_booking_modal_buttons();
      }
      if(response.confirm) {
        if(window.confirmEditBookingModal) {
          window.confirmEditBookingModal.show();
          $('#confirmEditBookingModal').find('.edit-booking-confirm-message-results').html(response.confirm);
          enable_booking_modal_buttons();
        }
      }
      if(response.success) {
        if(window.editBookingModal) {
          if(load_booking) {
            $('#editBookingModal').trigger('reload_booking', booking_id);
          } else {
            window.editBookingModal.hide();
            if($('.get-diary-form').length && !$('body').hasClass('public')) {
              if(response.diary_date) {
                $('.get-diary-form input[name="date"]').val(response.diary_date);
                global_func.change_diary_date($('.get-diary-form').first());
              }
            }
            $('.get-diary-form').trigger('submit');
          }
        }
        
        enable_booking_modal_buttons();
      }
    },
    error: function(response) {
      $('#editBookingModal .edit-booking-error-hold').html('');
      if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('errors')) {
        var error_message = '<div class="alert alert-danger"><ul>';
        $.each(response.responseJSON.errors, function(key,value) {
          error_message = error_message+'<li>'+value+'</li>';
        });
        error_message = error_message+'</ul></div>';
        $('#editBookingModal .edit-booking-error-hold').html(error_message);
      } else if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
        $('#editBookingModal .edit-booking-error-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
      }
      $('#editBookingModal .modal-body').scrollTop($('#editBookingModal .edit-booking-error-hold').offset().top);
      enable_booking_modal_buttons();
    }
  });
}

function diary_steps(el) {
  var active = $(el).find('.step.active').first();
  $(el).find('.step').removeClass('active');
  if(active.length==0) {
    $(el).find('.step:not(.skip)').first().addClass('active');
    active = $(el).find('.step').first();
  } else {
    $(active).addClass('active');
  }

  if(active.hasClass('locations-step')) {
    get_locations();
  }

  if(active.hasClass('tables-step')) {
    var checked_time = $('.booking-form input[name="time"]:checked').val();
    if(checked_time == "custom") {
      get_times_for_promotion($('.booking-form'), true);
    }
  }

  if(active.hasClass('times')) {
    //make sure we unset any time already checked.
    $('.booking-form').find('input[name="time"]').prop('checked', false);
    $('.booking-form').find('select[name="tables[]"] option').prop("selected", false);
    get_times_for_promotion($('.booking-form'));
  }

  if(active.hasClass('promotions-step')) {
    if($('.booking-form input[name="date"]').val()) {
       get_promotions_for_date($('.booking-form input[name="date"]').val(), $('.booking-form'));
    }
  }

  if(active.hasClass('payment-step')) {
    get_payment_intent(el);
  }

  if(active.hasClass('deposit-step')) {
    get_suggested_deposit(el);
    $(el).find('.booking-form-nav .next button').text('Take payment');
    $(el).find('input[name="store_card_details"]').val(0);
  } else {
    $(el).find('.booking-form-nav .next button').text('Next');
  }

  var first = $(el).find('.step:not(.skip)').first();
  var last = $(el).find('.step:not(.skip)').last();
  var payment = $(el).find('.step.payment-step:not(.skip)').last();
  if(active.is(first)) {
    $(el).find('.booking-form-nav .back').hide();
    $(el).find('.booking-form-nav .submit').hide();
    $(el).find('.booking-form-nav .next').show();
  } else if(active.is(last)) {
    $(el).find('.booking-form-nav .back').show();
    $(el).find('.booking-form-nav .submit').show();
    $(el).find('.booking-form-nav .next').hide();
  } else {
    $(el).find('.booking-form-nav .back').show();
    $(el).find('.booking-form-nav .submit').hide();
    $(el).find('.booking-form-nav .next').show();
  }

  if(active.is(payment)) {
    $(el).find('.booking-form-nav .submit').hide();
  }
}

function diary_step_next(el) {
  window.booking_form_validator.form();
  if(window.booking_form_validator.valid()) {
    // if($('.booking-details-public').length) {
    //   var old_height = $('.booking-details-public').height();
    //   var old_left = $('.booking-details-public .inner').offset().left + 5;
    //   var old_top = $('.booking-details-public .inner').offset().top + 5;
    //   $('.booking-details-public').addClass('loading');
    //   $('.booking-details-public .inner').css('top', old_top).css('left', old_left).addClass('fixed');
    //   $('.booking-details-public').height(old_height);


    //   var clone = $(el).clone().appendTo('#app').wrap('<div class="card"></div>').parent();
    //   $(clone).css('position', 'fixed').css('top', $(el).offset().top-30).css('left', '50%').css('pointer-events', 'none').css('z-index', '1001').css('transform', 'translateX(-50%)');
    // }

    var active = $(el).find('.step.active').first();
    var next = active.nextAll('.step:not(.skip)').first();

    // if($('.booking-details-public').length) {
    //   $(el).parent().addClass('loading');
    //   setTimeout(function() { 
    //     $(clone).addClass('form-transform');
    //     $(clone).css('transform', 'translateX(-100vw)');
    //   }, 100);
    // }

    if(active.hasClass('pin-step')) {
      get_employee();
    }

    if(next) {
      active.removeClass('active');
      next.addClass('active');
    }

    var $parent = $(el).parent();
    // Get the offset alone
    var offset = $parent.offset().top;
    // If the offset is less than the scroll position
    if (offset < $(window).scrollTop()) {
        $('html, body').animate({
                      // reuse your 'offset' variable instead of calculating it again
            scrollTop: offset
        }, 'slow');
    }

    // if($('.booking-details-public').length) {
    //   setTimeout(function() { 
    //     $(el).parent().removeClass('loading');
    //     $('.booking-details-public').removeClass('loading').css('height', 'auto');
    //     $('.booking-details-public .inner').removeClass('fixed').css('top', 'initial').css('left', 'initial');
    //     $(clone).remove();
    //   }, 500);
    // }
    diary_steps(el);
  }
}

function diary_step_back(el) {
  // if($('.booking-details-public').length) {
  //   var old_height = $('.booking-details-public').height();
  //   var old_left = $('.booking-details-public .inner').offset().left + 5;
  //   var old_top = $('.booking-details-public .inner').offset().top + 5;
  //   $('.booking-details-public').addClass('loading');
  //   $('.booking-details-public .inner').css('top', old_top).css('left', old_left).addClass('fixed');
  //   $('.booking-details-public').height(old_height);


  //   var clone = $(el).clone().appendTo('#app').wrap('<div class="card"></div>').parent();
  //   $(clone).css('position', 'fixed').css('top', $(el).offset().top-30).css('left', '50%').css('pointer-events', 'none').css('z-index', '1001').css('transform', 'translateX(-50%)');
  // }

  var active = $(el).find('.step.active').first();
  var prev = active.prevAll('.step:not(.skip)').first();

  // if($('.booking-details-public').length) {
  //   $(el).parent().addClass('loading');

  //   setTimeout(function() { 
  //     $(clone).addClass('form-transform');
  //     $(clone).css('transform', 'translateX(100vw)');
  //   }, 100);
  // }

  if(prev) {
    active.removeClass('active:not(.skip)');
    prev.addClass('active');
  }

  // if($('.booking-details-public').length) {
  //   setTimeout(function() { 
  //     $(el).parent().removeClass('loading');
  //     $('.booking-details-public').removeClass('loading').css('height', 'auto');
  //     $('.booking-details-public .inner').removeClass('fixed').css('top', 'initial').css('left', 'initial');
  //     $(clone).remove();
  //   }, 500);
  // }

  var $parent = $(el).parent();
  // Get the offset alone
  var offset = $parent.offset().top;
  // If the offset is less than the scroll position
  if (offset < $(window).scrollTop()) {
      $('html, body').animate({
                    // reuse your 'offset' variable instead of calculating it again
          scrollTop: offset
      }, 'slow');
  }
  diary_steps(el);
}

function num_selector_minus(el) {
  var current = parseInt(el.find('input').first().val());
  if(!current) {
    current = 0;
  }
  var min = el.find('input').first().attr('min');
  current = current - 1;
  if(min && current<parseInt(min)) {
    current = parseInt(min);
  }
  el.find('input').first().val(current).trigger('change');
}

function num_selector_plus(el) {
  var current = parseInt(el.find('input').first().val());
  if(!current) {
    current = 0;
  }
  var max = el.find('input').first().attr('max');
  current = current + 1;
  if(max && current>parseInt(max)) {
    current = parseInt(max);
  }
  el.find('input').first().val(current).trigger('change');
}

function get_suggested_deposit(booking_form) {
  disable_step_buttons();
  $(booking_form).find('input[name="payment_intent_id"').val('none');
  $.ajax({
    url: '/get-suggested-deposit',
    method: 'POST',
    data: $(booking_form).serialize(),
    dataType: 'JSON',
    cache: false,
    processData: false,
    success:function(response)
    {
      var deposit_text = $(booking_form).find('input[name="deposit_due"').val(response.deposit);

      // if(response.deposit<=0) {
      //   $(booking_form).find('.booking-form-nav .submit').show();
      //   $(booking_form).find('.booking-form-nav .next').hide();
      // } else {
      //   $(booking_form).find('.booking-form-nav .submit').hide();
      //   $(booking_form).find('.booking-form-nav .next').show();
      // }

      if(response.store_card) {
        $(booking_form).find('.store-card-details-link').show();
      } else {
        $(booking_form).find('.store-card-details-link').hide();
      }

      check_deposit_button_text(deposit_text);

      enable_step_buttons();
    },
    error: function(response) {
      enable_step_buttons();
    }
  });
}

function check_deposit_button_text(el) {
  if($(el).val()>0) {
    // $(el).parents('form.booking-form').first().find('.booking-form-nav .submit').hide();
    // $(el).parents('form.booking-form').first().find('.booking-form-nav .next').show();
    $(el).parents('form.booking-form').first().find('.booking-form-nav .next button').html('Take payment');
    $(el).parents('form.booking-form').first().find('.payment-type-hold').show();
  } else {
    // $(el).parents('form.booking-form').first().find('.booking-form-nav .submit').show();
    // $(el).parents('form.booking-form').first().find('.booking-form-nav .next').hide();
    $(el).parents('form.booking-form').first().find('.booking-form-nav .next button').html('Next');
    $(el).parents('form.booking-form').first().find('.payment-type-hold').hide();
  }
}

function charge_payment_link_form(booking_form) {
  var payment_url = $(booking_form).find('input[name="payment_charge_url"]').val();

  $.ajax({
    url: payment_url,
    method: 'POST',
    data: $(booking_form).serialize(),
    dataType: 'JSON',
    cache: false,
    processData: false,
    success:function(response)
    {
      $('#bookingErrorModal .error-modal-hold').html('');
      if(response.forceRefresh) {
        window.location = window.location.href;
      }
      if(response.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.message);
        window.bookingErrorModal.show();
        $(booking_form).find('.payment-loading').hide();
        $(booking_form).find('.payment-hold').show();
      }
      if(response.success) {
        if(window.newBookingModal) {
          window.newBookingModal.hide();
        }
        resetPayment(booking_form);
        $(booking_form).find('.payment-message').html('');
        $(booking_form).find('.payment-errors').html('');
        $(booking_form).find('.payment-loading').hide();
        $(booking_form).find('.payment-hold').show();

        if(response.booking_confirmation_url) {
          window.location = response.booking_confirmation_url;
        }
      }
    },
    error: function(response) {
      window.bookingErrorModal.show();
      $('#bookingErrorModal .error-modal-hold').html('');
      if(response.hasOwnProperty('responseJSON') && response.responseJSON.hasOwnProperty('message')) {
        $('#bookingErrorModal .error-modal-hold').html('<div class="alert alert-danger">'+response.responseJSON.message+'</div>');
      }
      $(booking_form).find('.payment-loading').hide();
      $(booking_form).find('.payment-hold').show();
    }
  });
}

function get_payment_intent(booking_form) {
  $(booking_form).find('.booking-payment').html('');
  $(booking_form).find('.booking-payment-wallet').html('');
  $(booking_form).find('.booking-deposit-html').html('');
  $(booking_form).find('#booking-pay').prop('disabled', true);
  $(booking_form).find('.payment-hold').hide(); 

  var payment_url = '/get-payment-intent';
  if($(booking_form).find('input[name="payment_retry_url"]').length && $(booking_form).find('input[name="payment_retry_url"]').val()!="") {
    payment_url = $(booking_form).find('input[name="payment_retry_url"]').val();
  }
  if($(booking_form).find('input[name="payment_intent_url"]').length) {
    var payment_url = $(booking_form).find('input[name="payment_intent_url"]').val();
  }
  

  disable_step_buttons();
  $.ajax({
    url: payment_url,
    method: 'POST',
    data: $(booking_form).serialize(),
    dataType: 'JSON',
    cache: false,
    processData: false,
    success:function(response)
    {
      if(response.booking_retry_url) {
        $(booking_form).find('input[name="booking_retry_url"]').val(response.booking_retry_url);
      }

      if(response.payment_retry_url) {
        $(booking_form).find('input[name="payment_retry_url"]').val(response.payment_retry_url);
      }

      if(response.error) {
        $('#bookingErrorModal .error-modal-hold').html(response.error);
        window.bookingErrorModal.show();
        enable_step_buttons();
      } else if(response.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.message);
        window.bookingErrorModal.show();
        enable_step_buttons();
        diary_step_back(booking_form);
      } else if(response.no_payment_needed) {
        skip_payment(booking_form);
      } else {
        $(booking_form).find('input[name="payment_intent_id"]').val(response.paymentIntent.id);
        $(booking_form).find('#booking-pay').prop('disabled', false);
        var payment_id = global_func.stringGen(10);
        $(booking_form).find('.booking-payment').attr('id', payment_id);
        const config = {
            paymentDetails: {
                paymentToken: response.paymentIntent.clientSessionSecret,
            },
            containerId: payment_id,
            fontCss: ['https://fonts.googleapis.com/css?family=Poppins'],
            styles: {
                base: {
                  default: {
                    'width': '100%',
                    'box-shadow': 'none',
                    'background-color': '#fff',
                    'padding': '0.375rem 0.75rem',
                    'border': '1px solid #ced4da',
                    'margin': '0',
                  },
                  label: {
                    'margin': '0 0 5px 0',
                    'display': 'block',
                  },
                  container: {
                    'padding': '10px',
                    'position': 'relative',
                    'flex': '0 0 auto',
                    'width': '50%',
                    'box-sizing': 'border-box',
                  }
                },
                cardNumber: {
                  container: {
                    'width': '100%',
                  }
                },
                cardName: {
                  container: {
                    'width': '100%',
                  }
                },
                cv2: {
                  default: {
                    'margin': '0 0 0 0',
                  }
                },
                cardIcon: { 
                  'bottom': '15px',
                  'right': '15px',
                  'margin-top': '0',
                },
                form: {
                  'font-family': "'Poppins', sans-serif",
                  'display': 'flex',
                  'flex-wrap': 'wrap',
                  'margin': '-10px',
                  '::after': {
                    'width': '0',
                    'display': 'none',
                  }
                }
            }
        };

        $(booking_form).find('.booking-deposit-html').html(response.deposit_html);
        var wallet_id = global_func.stringGen(10);
        $(booking_form).find('.booking-payment-wallet').attr('id', wallet_id);
        const walletconfig = {
          containerId: wallet_id,
          paymentDetails: {
              paymentToken: response.paymentIntent.clientSessionSecret,
          },
          buttonConfig: {
              color: 'black',
              type: 'plain'
          },
          emailRequired: true,
          billingAddressRequired: false,
          shippingAddressRequired: false
        };

        if(response.wallet) {
          window.wallet = new Dojo.WalletPayment(walletconfig, displayErrorsCallback, afterPayment);
        }

        window.card = new Dojo.Payment(config, displayErrorsCallback);

        enable_step_buttons();
        $(booking_form).find('.payment-hold').show();
      }

      
    },
    error: function(response) {
      $(booking_form).find('.payment-hold').show();
      console.log(response);
      enable_step_buttons();
      if(response.responseJSON.message) {
        $('#bookingErrorModal .error-modal-hold').html(response.responseJSON.message);
        window.bookingErrorModal.show();
        enable_step_buttons();
        diary_step_back(booking_form);
      }
    }
  });
}

function skip_payment(booking_form) {
  $(booking_form).find('.payment-hold').hide();
  enable_step_buttons();
  submit_new_booking_form(booking_form);
}

function submit_card_payment(button) {
  var btnTestPay = button;
  $(btnTestPay).hide();
  
  disable_step_buttons();
  var booking_form = $(btnTestPay).parents('form').last();
  $(booking_form).find('.booking-payment-wallet').hide();
  window.card.executePayment({
    mitConsentGiven: true,
  })
    .then(function (data) {
        console.log(data);
        afterPayment(data, booking_form);
        $(btnTestPay).show();
    }).catch(function (data) {
        $(btnTestPay).show();
        resetPayment(booking_form);
        get_payment_intent(booking_form);
        if (typeof data === 'string') {
            $(booking_form).find('.payment-message').html('<div class="alert alert-danger">'+data+'</div>');
        }
        if (data && data.message) {
            $(booking_form).find('.payment-message').html('<div class="alert alert-danger">'+data.message+'</div>');
        }
        enable_step_buttons();
    });
}

function afterPayment(data, booking_form=null) {
  enable_step_buttons();
  if(!booking_form) {
    var booking_form = $('body').find('form').first();
  }
  $(booking_form).find('.payment-message').html('');
  $(booking_form).find('.payment-errors').html('');
  if(data.statusCode==0) {
    $(booking_form).find('.booking-payment').hide();
    $(booking_form).find('.payment-loading').show();
    $(booking_form).find('.payment-hold').hide();
    if($(booking_form).hasClass('edit-booking-form')) {
      edit_booking(booking_form, true);
    } else if($(booking_form).hasClass('payment-link-form')) {
      charge_payment_link_form(booking_form);
    } else {
      submit_new_booking_form(booking_form);
      resetPayment(booking_form);
      $(booking_form).find('input[name="booking_retry_url"]').val("");
      $(booking_form).find('input[name="payment_retry_url"]').val("");
    }
  } else if(data.statusCode==5) {
    $(booking_form).find('.payment-message').html('<div class="alert alert-danger">The card was declined, please try again.</div>');
    resetPayment(booking_form);
    get_payment_intent(booking_form);
  } else {
    $(booking_form).find('.payment-message').html(response.message);
    resetPayment(booking_form);
    get_payment_intent(booking_form);
  }  
}

// handling payment errors
function displayErrorsCallback(errors) {
  $('body').find('.payment-errors').html('');
  if (errors && errors.length) {
    for (const error of errors) {
      $('body').find('.payment-errors').append('<li>'+error.message+'</li>');
    }
    $('body').find('.payment-errors').wrapInner('<div><ul class="alert alert-danger"></ul></div>');
  }
}

function resetPayment(booking_form) {
  $(booking_form).find('.booking-payment').html('');
  $(booking_form).find('.booking-payment').show();
  $(booking_form).find('.payment-errors').html('');
  $(booking_form).find('.booking-payment-wallet').html('');
  $(booking_form).find('.booking-payment').show();
  $(booking_form).find('.booking-payment-wallet').show();
}

function enable_step_buttons() {
  $('body').find('.booking-form-nav .back button').prop('disabled', false);
  $('body').find('.booking-form-nav .submit button').prop('disabled', false);
  $('body').find('.booking-form-nav .next button').prop('disabled', false);
}

function disable_step_buttons() {
  $('body').find('.booking-form-nav .back button').prop('disabled', true);
  $('body').find('.booking-form-nav .submit button').prop('disabled', true);
  $('body').find('.booking-form-nav .next button').prop('disabled', true);
}

function disable_booking_modal_buttons() {
  $('body').find('#editBookingModal .close-button').prop('disabled', true);
  $('body').find('#editBookingModal .submit-button').prop('disabled', true);
}

function enable_booking_modal_buttons() {
  $('body').find('#editBookingModal .close-button').prop('disabled', false);
  $('body').find('#editBookingModal .submit-button').prop('disabled', false);
}

function formatDate(dateString) {
    // Split the input date (DD/MM/YYYY)
    let parts = dateString.split('/');
    let day = parseInt(parts[0], 10);
    let month = parseInt(parts[1], 10) - 1; // Months are zero-based in JS
    let year = parseInt(parts[2], 10);

    // Create a new Date object
    let date = new Date(year, month, day);

    // Format the date
    let options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
    let formattedDate = date.toLocaleDateString('en-GB', options);

    // Add ordinal suffix (st, nd, rd, th)
    function getOrdinal(n) {
        if (n > 3 && n < 21) return 'th'; // covers 11th to 13th
        switch (n % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }

    // Add the ordinal suffix to the day
    formattedDate = formattedDate.replace(/\d+/, day + getOrdinal(day));

    return formattedDate;
}